<template>
    <button-primary @click="open()">
        <template slot="icon"><i class="fa fa-envelope"></i></template>
        User einladen
        <portal to="modal" v-if="showModal">
            <modal :show="showModal" @close="showModal = false">
                <div slot="header">User einladen</div>

                <input-text v-model="email" class="mb-8">
                    E-Mail
                </input-text>

                <toggle-group class="mb-4" v-model="ignore_scim" v-if="can.update.scim">
                    Active Directory Verwaltung
                    <template v-slot:helper>
                        Der Nutzer wird von der Active Directory Verwaltung ausgeschlossen
                    </template>
                </toggle-group>

                <div class="flex justify-end">
                    <loading v-show="loading"></loading>
                    <button-primary @click="invite" v-show="!loading">
                        <template slot="icon"><i class="fa fa-envelope"></i></template>
                        User einladen
                    </button-primary>
                </div>

            </modal>
        </portal>
    </button-primary>
</template>

<script>
import Modal from "./../Modal";
import ButtonSecondary from "./../UI/ButtonSecondary";
import ButtonPrimary from "../UI/ButtonPrimary";
import Loading from "../UI/Loading";
import InputText from "../UI/InputText";
import ToggleGroup from "../UI/ToggleGroup.vue";

export default {

    name: "UserInvite",

    components: {ToggleGroup, InputText, Loading, ButtonPrimary, ButtonSecondary, Modal},

    data: () => ({
        showModal: false,
        name: '',
        first_name: '',
        email: '',
        desk: '',
        ignore_scim: false,
        loading: false,
    }),

    inject: ['can'],

    methods: {
        open() {
            this.name = '';
            this.first_name = '';
            this.email = '';
            this.desk = '';
            this.ignore_scim = false;
            this.page = 'start';
            this.showModal = true;
        },
        invite() {
            this.loading = true;
            this.$http.post('/admin/user_invitees', {
                email: this.email,
                name: this.name,
                first_name: this.first_name,
                ignore_scim: this.ignore_scim,
                desk: this.desk,
            }).then(() => {
                this.loading = false;
                this.$emit('reload');
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            });
        }
    }
}

</script>
